export const personModel = {
  title: null,
  firstname: null,
  lastname: null,
  gender: null,
  profession_id: null,
  date_birth: null,
  date_death: null
}
